import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { RootState } from '../../../../store/root-reducer';
import Login from './login';
import {
  getAnonymousUserHashRequest,
  hideError,
  loginRequest,
} from './login-slice';

const mapStateToProps = (state: RootState) => ({
  loginStatus: state.login.status,
  loginMessage: state.login.message,
  loginError: state.login.error,
  token: state.login.token,
  trackingId: state.login.trackingId,
  firstName: state.login.firstName,
  lastName: state.login.lastName,
  email: state.login.email,
  showError: state.login.showError,
  anonymousUserHashStatus: state.login.anonymousUserHashStatus,
  anonymousUserHash: state.login.anonymousUserHash,
  anonymousUserId: state.login.anonymousUserId,
  agencyConfig: state.home.agencyConfig,
});

const mapDispatchToProps = {
  hideError: () => hideError(),
  sendLoginRequest: (email: string, password: string, captchaToken: string) =>
    loginRequest({ email, password, captchaToken }),
  sendGetAnonymousUserHashRequest: () => getAnonymousUserHashRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & RouteComponentProps;

export default connector(Login);
